const loginRouter = [{
  path: '/oldLogin',
  name: 'Login',
  component: () => import('@/views/login/oldLogin')

},
{
  // 此分支这个路由是微信扫码登录，如果需要改扫码登录，改这个页面
  path: '/login',
  name: 'Login',
  meta: {
    hideFoot: true,
    title: '登录'
  },
  component: () => import('@/views/login/newLogin.vue')
},
{
  // 驼铃知识库新登录流程（设计稿四步）
  path: '/newLogin',
  name: 'NewLogin',
  meta: {
    hideHead: true,
    hideFoot: true,
    title: '登录'
  },
  component: () => import('@/views/login_new/index.vue')
},
{
  path: '/bindPhone',
  name: 'BindPhone',
  meta: {
    title: '绑定手机',
    hideHead: true,
    hideFoot: true
  },
  component: () => import('@/views/login/bindPhone.vue')
}
]
export default loginRouter
